import cta from '../../images/cta/clip-bord.png'
import { Fade } from "react-awesome-reveal";


const CtaSection = (props) => {


    return (
        <section className={`cta ${props.cClass}`}>
            <div className="container">
                <div className="cta-wrap">
                    <div className="cta-inner ul_li_between">
                        <Fade direction='left' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <div className="xb-item--holder wow fadeInLeft" data-wow-delay="100ms"
                                    data-wow-duration="600ms">
                                    <h2 className="xb-item--title">Pare de perder clientes com atendimentos lentos.</h2>
                                    <span className="xb-item--content">Implante um agente de IA treinado para responder, vender e escalar com você.</span>
                                    <div className="xb-btn mt-45">
                                        <a 
                                            href="https://wa.me/5519981572542?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20Agentes%20de%20Inteligência%20Artificial.%20Podem%20me%20ajudar?" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="thm-btn thm-btn--aso thm-btn--aso_white"
                                        >
                                            Agendar demonstração gratuita
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                        <Fade direction='right' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <div className="cta-right_img wow fadeInRight" data-wow-delay="150ms" data-wow-duration="600ms">
                                    <img className="updown" src={cta} alt="" />
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CtaSection;